import type { Phrases } from '../../types';

const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

export type PhrasesWithEmail = Array<{ phraseIndex: number; emails: Phrases }>;

export function emailFinder(phrases: Phrases) {
  const phrasesWithEmail: PhrasesWithEmail = [];

  phrases.forEach((phrase, index) => {
    const emailsMatches = [...phrase.matchAll(emailRegex)];

    if (emailsMatches.length > 0) {
      const emails = emailsMatches.map((value) => value[0]);

      phrasesWithEmail.push({ phraseIndex: index, emails });
    }
  });

  return phrasesWithEmail;
}
